import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../_services/auth.service';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    
    // Check authentication status
    if (this.authService.isAuthenticated()) {
      return true;
    } else {
      // Store the attempted URL for redirecting after login
      const returnUrl = state.url;
      console.log('AuthGuard: User not authenticated, redirecting to login with returnUrl:', returnUrl);
      this.router.navigate(['/login'], { queryParams: { returnUrl } });
      return false;
    }
  }
}
